<template>
  <MHome v-if="$root.isMobile"></MHome>
  <div class="home" v-else>
      <Banner></Banner>
      <Cloud></Cloud>
      <!-- <PlateMessage></PlateMessage> -->
      <Register></Register>
  </div>
</template>

<script>
import Banner from '@/components/banner.vue'
import Cloud from './cloud-native.vue'
// import PlateMessage from './plate-message.vue'
import Register from './register.vue'
import MHome from '../../mobile/home.vue'

export default {
  name: 'Home',
  components: {
    Banner,
    Cloud,
    // PlateMessage,
    Register,
    MHome
  }
}
</script>
